import { OverrideCustomerRestrictionsCustomerId } from "../../components/shared/constants";

// Matching the logic in RestrictionService.GetEffectiveRestriction (moved from ProductService)
export const getLastCustomerRestriction = (restrictions, customerId) => {
    if (!restrictions?.length) return null;

    var firstRestrictionMatchingCurrentCustomer = restrictions.find(r => r.CustomerId === customerId ||
        r.CustomerId === OverrideCustomerRestrictionsCustomerId);

    // Only a general row, a row for this same customer, or another sentinel row may supersede the
    // override sentinel — an unrelated customer's row must not (cross-customer contamination).
    var restrictionAfterOverride = firstRestrictionMatchingCurrentCustomer?.CustomerId == OverrideCustomerRestrictionsCustomerId ?
        restrictions.find(r => r.CreateDate > firstRestrictionMatchingCurrentCustomer.CreateDate &&
            (r.CustomerId === undefined ||
                r.CustomerId === customerId ||
                r.CustomerId === OverrideCustomerRestrictionsCustomerId)) :
        null;

    if (restrictionAfterOverride != null) return restrictionAfterOverride;

    return firstRestrictionMatchingCurrentCustomer ?? restrictions.find(r => r.CustomerId === undefined);
};
